<template>
  <div class="wrapper">
    <nav id="sidebar" class="sidebar js-sidebar" :class="{'collapsed': sidebar && isMobile}" v-if="sidebar">
      <div class="sidebar-content js-simplebar">
        <a class="sidebar-brand" href="/admin">
          <span class="align-middle"><img src="../assets/images/home/logo.png" alt="..."></span>
        </a>

        <ul class="sidebar-nav">
          <li class="sidebar-item active">
            <router-link to="/admin/members" class="sidebar-link">
              <i class="align-middle" data-feather="sliders"></i> <span class="align-middle">Members Registration</span>
            </router-link>
          </li>
          <li class="sidebar-item active">
            <router-link to="/admin/businesses" class="sidebar-link">
              <i class="align-middle" data-feather="sliders"></i> <span
                class="align-middle">Business Registration</span>
            </router-link>
          </li>
          <li class="sidebar-item active">
            <router-link to="/admin/contacts" class="sidebar-link">
              <i class="align-middle" data-feather="sliders"></i> <span class="align-middle">Contact</span>
            </router-link>
          </li>
          <li class="sidebar-item active">
            <router-link to="/admin/newsletters" class="sidebar-link">
              <i class="align-middle" data-feather="sliders"></i> <span class="align-middle">Newsletter</span>
            </router-link>
          </li>
          <li class="sidebar-item active">
            <router-link to="/admin/entities" class="sidebar-link">
              <i class="align-middle" data-feather="sliders"></i> <span class="align-middle">Entity Application</span>
            </router-link>
          </li>
        </ul>

      </div>
    </nav>

    <div class="main">
      <nav class="navbar navbar-expand navbar-light navbar-bg">
        <a class="sidebar-toggle js-sidebar-toggle" @click.prevent="sidebar = !sidebar">
          <i class="hamburger align-self-center"></i>
        </a>

        <div class="navbar-collapse collapse">
          <ul class="navbar-nav navbar-align">
            <li class="nav-item dropdown">
              <a class="nav-icon dropdown-toggle d-inline-block d-sm-none" href="#" data-bs-toggle="dropdown">
                <i class="align-middle" data-feather="settings"></i>
              </a>
              <a v-if="user" class="nav-link dropdown-toggle d-none d-sm-inline-block" href="#"
                 data-bs-toggle="dropdown">
                <span class="text-dark">{{ user.email }}</span>
              </a>
              <div class="dropdown-menu dropdown-menu-end">
                <a class="dropdown-item" @click.prevent="logout" href="#">Log out</a>
              </div>
            </li>
          </ul>
        </div>
      </nav>

      <main class="content">
        <div class="container-fluid p-0">

          <div class="row mb-4" v-if="$route.params.type === 'members' && error !== ''">
            <div class="col-12 col-lg-12 col-xxl-12 d-flex flex-column alert-danger alert">
              {{ error }}
            </div>
          </div>

          <div class="row mb-4" v-if="$route.params.type === 'members' && success !== ''">
            <div class="col-12 col-lg-12 col-xxl-12 d-flex flex-column alert-success alert">
              {{ success }}
            </div>
          </div>

          <div class="row mb-4" v-if="$route.params.type === 'members' && showAllPaths">
            <div class="col-12 col-lg-12 col-xxl-12 d-flex flex-column">
              <Select2 style="width: 100%;" class="form-control" v-model="selectedPaths" :options="allPaths"
                       placeholder="Select Paths" multiple="required"/>
              <button class="btn btn-sm btn-primary" :disabled="selectedPaths.length === 0 || loading"
                      @click.prevent="updateMember">
                <span
                    v-show="loading"
                    class="spinner-border spinner-border-sm"
                ></span>
                <span>Update Member</span></button>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-lg-12 col-xxl-12 d-flex">
              <Table @showAllPaths="showAllPaths = !showAllPaths" @selectedMember="setSelectedMember" v-if="data.length"
                     :type="$route.params.type" :data="data[1]" :title="data[0]"/>
            </div>
          </div>

        </div>
      </main>

    </div>
  </div>
</template>

<script>
import AdminService from "../services/admin.service";
import Table from "@/components/Table";

export default {
  components: {Table},
  data() {
    return {
      loading: false,
      error: '',
      success: '',
      showAllPaths: false,
      selectedMember: null,
      selectedPaths: [],
      paths: null,
      entities: null,
      members: null,
      businesses: null,
      contacts: null,
      newsletters: null,
      sidebar: true,
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    }
  },
  mounted() {
    this.$store.dispatch('auth/getUserData');
    AdminService.getMembers().then(
        (response) => {
          this.members = response.data;
        },
        () => {
          this.logout();
        }
    );
    AdminService.getBusinesses().then(
        (response) => {
          this.businesses = response.data;
        },
        () => {
          this.logout();
        }
    );
    AdminService.getContacts().then(
        (response) => {
          this.contacts = response.data;
        },
        () => {
          this.logout();
        }
    );
    AdminService.getNewsletters().then(
        (response) => {
          this.newsletters = response.data;
        },
        () => {
          this.logout();
        }
    );
    AdminService.getEntityUsers().then(
        (response) => {
          this.entities = response.data;
        },
        () => {
          this.logout();
        }
    );
    AdminService.getPaths().then(
        (response) => {
          this.paths = response.data;
        },
        () => {
          this.logout();
        }
    );
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout").then(
          () => {
            this.$router.push("/login");
          },
      );
    },
    setSelectedMember(event) {
      this.selectedMember = event;
    },
    updateMember() {
      this.loading = true;
      let data = {
        'paths': this.selectedPaths
      }
      AdminService.updateMember(this.selectedMember, data).then(
          (response) => {
            this.success = response.data;
            AdminService.getMembers().then(
                (response) => {
                  this.members = response.data;
                },
            );
          },
          (error) => {
            this.error = error.data;
          }
      );
      this.showAllPaths = false;
      this.loading = false;
    }
  },
  computed: {
    user() {
      return this.$store.getters["auth/userData"];
    },
    allPaths() {
      if (this.paths !== null) {
        return this.paths.map(path => {
          return {
            'id': path.id,
            'text': path.name + ' LEVEL: ' + path.level,
          }
        })
      }
      return [];
    },
    data() {
      if (this.$route.params.type === 'members') {
        return ['Member Registration', this.members];
      } else if (this.$route.params.type === 'businesses') {
        return ['Business Registration', this.businesses];
      } else if (this.$route.params.type === 'contacts') {
        return ['Contacts', this.contacts];
      } else if (this.$route.params.type === 'newsletters') {
        return ['Newsletters', this.newsletters];
      } else if (this.$route.params.type === 'entities') {
        return ['Entities Applications', this.entities];
      }
      return [];
    }
  }
}
</script>

<style>
@import "../assets/admin/css/app.css";
</style>
